module.exports = __webpack_public_path__ + "static/media/treat_img_2.9a615ec0.png";